console.log('Vite ⚡️ Rails')
